/**
 * Declarações de EPI do LTCAT (#468): as respostas por cargo que o painel da emissão lê e grava.
 */
import apiClient from './apiClient';
import type { LtcatEpiDeclaracaoAlteracao, LtcatEpiDeclaracoesPainel } from '../types/document';
import type { RiskApplicationScope } from '../types/riskApplication';

/** O alcance e o período da emissão: o mesmo recorte da prévia, senão a vigência diverge. */
export interface ConsultaDeclaracoesEpi {
  scope: RiskApplicationScope;
  scopeId: number;
  periodStart: string;
  periodEnd: string;
}

class LtcatEpiDeclaracoesService {
  private url = '/documents/ltcat/epi-declaracoes';

  async obter(consulta: ConsultaDeclaracoesEpi): Promise<LtcatEpiDeclaracoesPainel> {
    const params = new URLSearchParams({
      scope: consulta.scope,
      scopeId: String(consulta.scopeId),
      periodStart: consulta.periodStart,
      periodEnd: consulta.periodEnd,
    });
    const response = await apiClient.get<LtcatEpiDeclaracoesPainel>(`${this.url}?${params.toString()}`);
    return response.data as LtcatEpiDeclaracoesPainel;
  }

  /** Grava só as células alteradas. Conflito (409) rejeita com os conflitos no corpo do erro. */
  async salvar(
    consulta: ConsultaDeclaracoesEpi,
    changes: LtcatEpiDeclaracaoAlteracao[]
  ): Promise<LtcatEpiDeclaracoesPainel> {
    const response = await apiClient.put<LtcatEpiDeclaracoesPainel>(this.url, { ...consulta, changes });
    return response.data as LtcatEpiDeclaracoesPainel;
  }
}

export const ltcatEpiDeclaracoesService = new LtcatEpiDeclaracoesService();
export default ltcatEpiDeclaracoesService;
